(function(angular){
	'use strict';
	
	var riskAdjustedReturnScatterplotObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			defaultReitId: '<',
			reitElements: '<',
			activeProjectCount: '=?'
		},
		controller: [
			'$filter',
			'$rootScope',
			'$scope',
			'RISE_CO_REIT_ID',
			'Big',
			'PropertyService',
			'ReitElementTooltipFactory',
			RiskAdjustedReturnScatterplotFunction
		],
		controllerAs: 'riskAdjustedReturnScatterplot'
	};
	
	angular
		.module('riskAdjustedReturnModule')
		.component('riskAdjustedReturnScatterplot', riskAdjustedReturnScatterplotObject);

	function templateUrlFunction(STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/shared/charts/risk-adjusted-return-scatterplot/risk-adjusted-return-scatterplot.html';
	}

	function RiskAdjustedReturnScatterplotFunction(
		$filter,
		$rootScope,
		$scope,
		RISE_CO_REIT_ID,
		Big,
		PropertyService,
		ReitElementTooltipFactory
	){
		var riskAdjustedReturnScatterplot = this;

		var chartOptions = {
			chart: {
				type: 'scatter'
			},
			plotOptions: {
				series: {
					marker: {
						symbol: 'circle'
					},
					stickyTracking: false
				}
			},
			series: [{
				id: 'rangeCone',
				color: 'transparent',
				fillColor: {
					linearGradient: { x1: 0.5, y1: 0, x2: 1, y2: 0 },
					stops: [
						[0, 'rgba(0,0,0,0.05)'],
						[0.75, 'rgba(0,0,0,0)']
					]
				},
				type: 'arearange',
				data: [
					[5,5.5,5], [21,22,12.5]
				]
			}],
			tooltip: {
				enabled: true,
				useHTML: true,
				padding: 0,
				borderWidth: 0,
				backgroundColor: 'transparent',
				hideDelay: 100,
				shadow: false,
				snap: 10,
				formatter: function() {
					if(this.series.type === 'line' || this.series.userOptions.state === 'muted') {
						return false;
					} else {
						var tooltip = ReitElementTooltipFactory.buildReitElementTooltip(this.point.reitElement);
						return tooltip;
					}
				}
			},
			xAxis: {
				categories: [0, 1, 2, 3, 4, 5, "A1", "A2", "A3", "B1", "B2", "B3", "C1", "C2", "C3", "D1", "D2", "D3", "E1", "E2", "E3"],
				labels: {
					formatter: function() {
						var letter = this.value.charAt(0);
						var color = $filter('riskLetterToColor')(letter);
						return '<span style="font-weight:bold;color:' + color + '">' + this.value + '</span>';
					},
					step: 3,
					style: {
						color: 'hsl(210,10%,55%)'
					}
				},
				min: 6,
				max: 20,
				tickInterval: 1,
				tickmarkPlacement: 'on',
				title: {
					text: 'Fundrise rating'
				}
			},
			yAxis: {
				min: 6,
				max: 18,
				floor: 4,
				tickInterval: 2,
				labels: {
					formatter: function() {
						return this.value + '%';
					}
				},
				title: {
					text: 'Projected return'
				}
			}
		};


		function initChart(data) {
			var formattedSeries = getSeriesList(data);
			chartOptions.series = chartOptions.series.concat(formattedSeries);
			riskAdjustedReturnScatterplot.chartOptions = chartOptions;
		}

		function getDataPoint(reitElement) {
			var projectedReturnAsBig = getProjectedReturn(reitElement);

			var dataPoint = {
				projectedReturn: getProjectedReturn(reitElement),
				x: reitElement.riskScore,
				y: parseFloat(projectedReturnAsBig),
				color: reitElement.rating.color,
				reitElement: reitElement,
				activeColor: reitElement.rating.color,
				mutedColor: '#e3e6e8'
			};

			return dataPoint;
		}

		function getProjectedReturn(reitElement) {
			var projectedReturn;

			if(reitElement.structure === 'Debt') {
				projectedReturn = new Big(reitElement.annualInterestRate).times(100);
			} else {
				var bigLowerBound = new Big(reitElement.projectedReturnLowerBound);
				var bigUpperBound = new Big(reitElement.projectedReturnUpperBound);
				projectedReturn = bigLowerBound.plus(bigUpperBound).div(2).times(100);
			}

			return projectedReturn;
		}

		function getSeries(reitElements) {
			var series = {
				data: [],
				type: 'scatter'
			};

			angular.forEach(reitElements, function(reitElement) {
				var dataPoint = getDataPoint(reitElement);
				series.data.push(dataPoint);
			});	

			return series;
		}

		function getSeriesList(reitElements) {
			var seriesList = [];

			angular.forEach(reitElements, function(reitElement) {
				angular.forEach(reitElement.reits, function(reit) {
					var parentReitSeriesObj = getParentReitSeriesObj(seriesList, reit.id);
					var dataPoint = getDataPoint(reitElement);
					if(angular.isUndefined(parentReitSeriesObj)) {
						parentReitSeriesObj = createNewSeriesObj(reit.id);
						seriesList.push(parentReitSeriesObj);
					}
					parentReitSeriesObj.data.push(dataPoint);
				});
			});			

			return seriesList;
		}

		function getParentReitSeriesObj(seriesList, reitId) {
			var parentReitSeriesObj;

			angular.forEach(seriesList, function(seriesObj) {
				if(seriesObj.id === reitId) {
					parentReitSeriesObj = seriesObj;
				}
			});

			return parentReitSeriesObj;
		}

		function createNewSeriesObj(reitId) {
			var enableInteractivity = !angular.isDefined(riskAdjustedReturnScatterplot.defaultReitId) || parseInt(reitId) === riskAdjustedReturnScatterplot.defaultReitId;
			var seriesObj = {
				id: reitId,
				data: []
			};

			if(enableInteractivity) {
				seriesObj.cursor = 'pointer';
				seriesObj.point = {
					events: {
						click: function(e) {
							$rootScope.ModalFactory.openReitElement({
								reitElement: this.reitElement
							});
						}
					}
				};
				seriesObj.states = {
					hover: {
						enabled: true
					}
				};
			}

			return seriesObj;
		}

		function setState(seriesList, reitId) {
			var activeSeries;

			angular.forEach(seriesList, function(series) {

				var ignoreSeries = series.userOptions.id === 'rangeCone';

				if(!ignoreSeries) {
					var seriesState = getSeriesState(series, reitId);
					if(seriesState === 'active') {
						activeSeries = series;
					}
					updateSeries(series, seriesState);
				}
			});
			
			riskAdjustedReturnScatterplot.chartReference.redraw();

			$scope.$applyAsync(function() {
				if(activeSeries) {
					riskAdjustedReturnScatterplot.activeProjectCount = activeSeries.points.length;
				} else if(angular.isDefined(riskAdjustedReturnScatterplot.defaultReitId) || reitId) {
					riskAdjustedReturnScatterplot.activeProjectCount = 0;
				} else {
					riskAdjustedReturnScatterplot.activeProjectCount = riskAdjustedReturnScatterplot.totalProjectCount;
				}
			});
		}

		function updateSeries(series, seriesState) {
			angular.forEach(series.points, function(point) {
				var color = seriesState !== 'muted' ? point.activeColor : point.mutedColor;
				point.update({
					color: color
				}, false);

			});

			var zIndex;
			if(seriesState === 'active') {
				zIndex = 2;
			} else if(seriesState === 'muted') {
				zIndex = -1;
			} else {
				zIndex = 1;
			}

			series.update({
				zIndex: zIndex,
				state: seriesState
			}, false);
		}

		function getSeriesState(series, reitId) {
			var seriesState;
			var defaultReitId = riskAdjustedReturnScatterplot.defaultReitId;
			
			if(angular.isDefined(reitId)) {
				if(parseInt(series.userOptions.id) === parseInt(reitId)) {
					seriesState = 'active';
				} else {
					seriesState = 'muted';
				}
			} else if(angular.isDefined(defaultReitId)) {
				if(parseInt(series.userOptions.id) === parseInt(defaultReitId)) {
					seriesState = 'active';
				} else {
					seriesState = 'muted';
				}
			} else {
				seriesState = 'default';
			}

			return seriesState;
		}

		$rootScope.$on('reit.mouseOver', function(event, reitId) {
			if(riskAdjustedReturnScatterplot.chartReference) {
				setState(riskAdjustedReturnScatterplot.chartReference.series, reitId);
			}
		});

		$rootScope.$on('reit.mouseOut', function(event) {
			if(riskAdjustedReturnScatterplot.chartReference) {
				setState(riskAdjustedReturnScatterplot.chartReference.series);
			}
		});

		$scope.$on('highchart.load', function(event, chart) {
			riskAdjustedReturnScatterplot.chartReference = chart;
		});

		riskAdjustedReturnScatterplot.$onChanges = function(changeObj) {
			if(changeObj.reitElements && changeObj.reitElements.currentValue) {
				initChart(changeObj.reitElements.currentValue);
				riskAdjustedReturnScatterplot.totalProjectCount = changeObj.reitElements.currentValue.length;
				riskAdjustedReturnScatterplot.activeProjectCount = riskAdjustedReturnScatterplot.totalProjectCount;
			}
		};
	}
})(window.angular);